var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25608",
    "data-name": "Group 25608",
    transform: "translate(-336 -1144)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 36,
    height: 36,
    transform: "translate(336 1144)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M24,0H3A3.009,3.009,0,0,0,0,3V24a3.009,3.009,0,0,0,3,3H24a3.009,3.009,0,0,0,3-3V3A3.009,3.009,0,0,0,24,0Z",
    transform: "translate(340.5 1148.5)",
    fill: "#ae20ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M.153,5.809l3-4.005a.744.744,0,0,1,1.2,0l2.775,3.7,3.9-5.2a.744.744,0,0,1,1.2,0l4.125,5.505a.75.75,0,0,1-.6,1.2h-15A.75.75,0,0,1,.153,5.809Z",
    transform: "translate(345.747 1162.491)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/IMAGE.8e96f500e5dfcea30fa35c60a09c4574.svg";
export { ForwardRef as ReactComponent };